import script from "./FileNotices.vue?vue&type=script&setup=true&lang=js"
export * from "./FileNotices.vue?vue&type=script&setup=true&lang=js"

import "./FileNotices.vue?vue&type=style&index=0&id=8d8e06c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d8e06c4"]])

export default __exports__